/**
 * Utility to migrate settings from localStorage to database
 * This should be called once when user logs in if they have old localStorage data
 */

import { buildApiUrl } from '../config/api';

export const migrateLocalStorageSettings = async (token: string): Promise<void> => {
  try {
    // Check if migration has already been done
    const migrationDone = localStorage.getItem('settings_migrated');
    if (migrationDone === 'true') {
      return;
    }

    // Get theme from localStorage
    const localTheme = localStorage.getItem('theme');
    
    // Get language from i18next localStorage
    const localLanguage = localStorage.getItem('i18nextLng');
    
    const updates: Record<string, any> = {};
    
    if (localTheme) {
      updates.darkMode = localTheme === 'dark';
    }
    
    if (localLanguage && (localLanguage === 'es' || localLanguage === 'en')) {
      updates.language = localLanguage;
    }
    
    // Only proceed if we have something to migrate
    if (Object.keys(updates).length > 0) {
      const response = await fetch(buildApiUrl('/api/settings'), {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      });
      
      if (response.ok) {
        // Mark migration as done
        localStorage.setItem('settings_migrated', 'true');
      }
    } else {
      // No settings to migrate, mark as done anyway
      localStorage.setItem('settings_migrated', 'true');
    }
  } catch (error) {
    console.error('Error migrating localStorage settings:', error);
    // Don't mark as migrated on error, so it can be retried
  }
};